export default [
  {
    source: {
      url: "mapbox://mepa1363.1ncv1o6f"
    },
    layer: {
      id: "safety-flood-probability-1",
      source: "pickyourplace_flood_1",
      color: "#43a2ca"
    },
    label: {
      text: "1%",
      description: "Indicates the event probability of 1 in 100 years."
    }
  },
  {
    source: {
      url: "mapbox://mepa1363.5k55a3l7"
    },
    layer: {
      id: "safety-flood-probability-5",
      source: "pickyourplace_flood_5",
      color: "#43a2ca"
    },
    label: {
      text: "5%",
      description: "Indicates the event probability of 1 in 20 years."
    }
  },
  {
    source: {
      url: "mapbox://mepa1363.0ofoq57b"
    },
    layer: {
      id: "safety-flood-probability-10",
      source: "pickyourplace_flood_10",
      color: "#43a2ca"
    },
    label: {
      text: "10%",
      description: "Indicates the event probability of 1 in 10 years."
    }
  },
  {
    source: {
      url: "mapbox://mepa1363.d8u309g9"
    },
    layer: {
      id: "safety-flood-probability-20",
      source: "pickyourplace_flood_20",
      color: "#43a2ca"
    },
    label: {
      text: "20%",
      description: "Indicates the event probability of 1 in 5 years."
    }
  }
];
